import { useState, useEffect, useContext, memo, ChangeEvent } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import Styles from './styles/CategorizationTable.styles';
import themev5 from '../../themev5';
import { ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import tabStyle from '../CBER/styles/Tabs.styles'
import utils from '../Datagrid/utils'
// api
import { getLabelPlrData, getLabelNonPlrData, getLabelData } from '../../api/Cber'

// context
import Store from '../../store';
import Actions from '../../store/actions';

import {
    Typography,
    Button,
    Grid,
    Box,
    TextField
} from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import StyledTabs, { StyledTab } from '../StyledComponents/VivproTabs';
import styles from '../Datagrid/Datagrid.styles';
import { DataGrid } from '@mui/x-data-grid/DataGrid';
import DatagridFooter from '../Datagrid/DatagridFooter';
import DatagridNoRowsOverlay from '../Datagrid/DatagridNoRowsOverlay';
import LinearProgress from '@material-ui/core/LinearProgress';
import CssBaseline from '@mui/material/CssBaseline';
import { Dialog } from '@mui/material';
import LabelSectionEditDialog from './LabelSectionEditDialog'
const qc_status = [
    'All Documents',
    'Escalate',
    'Missing Details',
    'Non QCed',
    'QCed'
];

const LabelSection = () => {
    const history = useHistory()
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const table_status = params.get('qc_status');
    const application_number = params.get('application_number');
    const { dispatch } = useContext<any>(Store);
    const classes = Styles();
    const [plrKey, setPlrKey] = useState<Array<any>>([]);
    const [plrPageNo, setPlrPageNo] = useState(0);
    const [plrRowCount, setPlrRowCount] = useState();
    const [pageSize, setPageSize] = useState(10);
    const [nonPlrKey, setNonPlrKey] = useState<Array<any>>([]);
    const [nonPlrPageNo, setNonPlrPageNo] = useState(0);
    const [nonPlrRowCount, setNonPlrRowCount] = useState();
    const [nonPlrPageSize, setNonPlePageSize] = useState(10);
    const [searchText, setSearchText] = useState(application_number || "")
    const [status, setStatus] = useState(table_status || "All Documents")
    const [loading, setloading] = useState(true)
    const [selectedTab, setSelectedTab] = useState<string>(location.pathname.includes('plr') ? 'PLR' : 'NON-PLR');
    const rowsPerPageOptions = [10, 20, 50, 100];
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [docsId, setDocsId] = useState()
    const [applicationNumber, setApplicationNumber] = useState()

    const onTabChange = (e: React.SyntheticEvent, newValue: string) => {
        history.push(`/cber/label_section/${newValue.toLowerCase()}`)
        setSearchText("");
        setStatus("All Documents")
        setSelectedTab(newValue);
        setPlrPageNo(0);
        setNonPlrPageNo(0);
    };
    useEffect(() => {
        const getPlrData = async () => {
            try {
                const result = await getLabelPlrData(plrPageNo, pageSize, status === "Non QCed" ? "to_qc" : status.toLowerCase(), searchText.trim().toLowerCase());
                if (result === undefined) {
                    throw new Error("Result is undefined")
                }
                if (result.data && result.data.body.results) {
                    setloading(false)
                    let resultData = result.data.body.results;
                    setPlrRowCount(result.data.body.total_rows)
                    setPlrKey([...resultData?.map((item: any, index: number) => ({ ...item, id: index }))]);
                }
                else {
                    setloading(false)
                    throw Error('No data');
                }
            } catch (e: any) {
                await dispatch({
                    type: Actions.SET_ALERT,
                    value: { status: true, message: e.message }
                });
            }
        };
        getPlrData();
    }, [plrPageNo, status, searchText, pageSize])

    useEffect(() => {
        const getNonPlrData = async () => {
            try {
                const result = await getLabelNonPlrData(nonPlrPageNo, pageSize, status === "Non QCed" ? "to_qc" : status.toLowerCase(), searchText.trim().toLowerCase())
                if (result === undefined) {
                    throw new Error("Result is undefined")
                }
                if (result.data && result.data.body.results) {
                    setloading(false)
                    let resultData = result.data.body.results;
                    setNonPlrRowCount(result.data.body.total_rows)
                    setNonPlrKey([...resultData?.map((item: any, index: number) => ({ ...item, id: index }))]);
                }
                else {
                    setloading(false)
                    throw Error('No data');
                }
            } catch (e: any) {
                await dispatch({
                    type: Actions.SET_ALERT,
                    value: { status: true, message: e.message }
                });
            }
        };
        getNonPlrData();
    }, [nonPlrPageNo, status, searchText, nonPlrPageSize])

    const openEdit = (data: any) => {
        setShowEditDialog(true);
        setDocsId(data.application_docs_id);
        setApplicationNumber(data.application_number)
    };
    const closeEdit = () => {
        setShowEditDialog(false);
    };
    const plrColumns = [
        {
            field: 'Edit',
            width: 100,
            headerClassName: "MuiDataGrid-columnHeader",
            cellClassName: "ria-MuiDataGrid-cell",
            headerAlign: 'center',
            renderCell: (params: any) => {
                return (
                    <Button
                        variant='contained'
                        className={classes.Button}
                        onClick={() => {
                            openEdit(params.row);
                        }}>
                        <Typography>Edit</Typography>
                    </Button>
                );
            }
        },
        {
            field: 'application_number',
            headerName: 'Application Number',
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'title',
            headerName: 'PDF Title',
            width: 500,
            renderCell: (params: any) => (
                <Grid item xs={8} lg={8}>
                    <Tooltip title={params.row.title} >
                        <Typography style={{ fontSize: '17px' }}>
                            {params.row.title.length > 65 ? params.row.title.substring(0, 65) + "..." : params.row.title}
                        </Typography>
                    </Tooltip>
                </Grid>
            )
        },
        {
            field: 'qc_status',
            headerName: 'QC Status',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <Grid item xs={8} lg={8}>
                    {params.row.qc_status === "qced" ? "QCed" : params.row.qc_status === "to_qc" ? "Non QCed" : utils(params.row.qc_status, 'formulations')}
                </Grid>)
        },
        {
            field: 'submission_number',
            headerName: 'Submission Number',
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'submission_type',
            headerName: 'Submission Type',
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
    ];
    const nonPlrColumns = [
        {
            field: 'Edit',
            width: 100,
            headerClassName: "MuiDataGrid-columnHeader",
            cellClassName: "ria-MuiDataGrid-cell",
            headerAlign: 'center',
            renderCell: (params: any) => {
                return (
                    <Button
                        variant='contained'
                        className={classes.Button}
                        onClick={() => {
                            openEdit(params.row);
                        }}>
                        <Typography>Edit</Typography>
                    </Button>
                );
            }
        },
        {
            field: 'application_number',
            headerName: 'Application Number',
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'title',
            headerName: 'PDF Title',
            width: 500,
            renderCell: (params: any) => (
                <Grid item xs={8} lg={8}>
                    <Tooltip title={params.row.title} >
                        <Typography style={{ fontSize: '17px' }}>
                            {params.row.title.length > 65 ? params.row.title.substring(0, 65) + "..." : params.row.title}
                        </Typography>
                    </Tooltip>
                </Grid>
            )
        },
        {
            field: 'qc_status',
            headerName: 'QC Status',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <Grid item xs={8} lg={8}>
                    {params.row.qc_status === "qced" ? "QCed" : params.row.qc_status === "to_qc" ? "Non QCed" : utils(params.row.qc_status, 'formulations')}
                </Grid>)
        },
        {
            field: 'submission_number',
            headerName: 'Submission Number',
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'submission_type',
            headerName: 'Submission Type',
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
    ];
    return (
        <ThemeProvider theme={themev5}>
            <CssBaseline />
            <Box display='flex' flexDirection='column' ml={2} mt={10} >
                <AppBar position='static' color='transparent' elevation={0} sx={tabStyle.tabContainer}>
                    <StyledTabs
                        value={selectedTab}
                        onChange={(e: React.SyntheticEvent, newValue: string) => {
                            onTabChange(e, newValue)
                        }}
                        aria-label='tabs'
                        sx={{ paddingLeft: 1, marginBottom: '-1px' }}
                        indicatorColor='primary'>
                        <StyledTab
                            value='PLR'
                            id='plr'
                            label='PLR'
                            sx={selectedTab === 'PLR' ? tabStyle.activeTab : tabStyle.inactiveTab}
                            activetab={(selectedTab === 'PLR').toString()}
                        />
                        <StyledTab
                            value='NON-PLR'
                            id='non-plr'
                            label='NON-PLR'
                            sx={selectedTab === 'NON-PLR' ? tabStyle.activeTab : tabStyle.inactiveTab}
                            activetab={(selectedTab === 'NON-PLR').toString()}
                        />
                    </StyledTabs>
                </AppBar>
                <Box display='flex' padding={1} alignItems='center' justifyContent='start'>
                    <Autocomplete
                        id='qc_status'
                        value={status}
                        onChange={(event: ChangeEvent<{}>, newValue: string | null): void => {
                            if (newValue !== null) {
                                setStatus(newValue);
                                setPlrPageNo(0);
                                setNonPlrPageNo(0);
                            }
                        }}
                        style={{ fontSize: '1.5vh', minWidth: '250px', marginRight: '10px' }}
                        options={qc_status}
                        renderInput={(params: any) => <TextField {...params} placeholder="QC Status" label="QC Status" variant='outlined' />}
                    />
                    <TextField
                        variant='outlined'
                        type='search'
                        id='search_application'
                        label='Search Application Number'
                        value={searchText}
                        InputProps={{
                            style: { fontSize: '1.5vh', minWidth: '250px' }
                        }}
                        InputLabelProps={{
                            style: { fontSize: '1.5vh' }
                        }}
                        onChange={e => {
                            setSearchText(e.target.value);
                            setPlrPageNo(0);
                            setNonPlrPageNo(0);
                        }}
                    />
                </Box>
                <Box
                    height='70vh'
                    mt={1}
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    className={classes.root}>
                    {
                        selectedTab === "PLR" ? (
                            <DataGrid
                                sx={styles.datagrid}
                                rowSpacingType='margin'
                                sortingOrder={['desc', 'asc']}
                                checkboxSelection={false}
                                density='standard'
                                rows={plrKey}
                                columns={plrColumns as any}
                                rowCount={plrRowCount}
                                pageSize={pageSize}
                                getRowId={row => row.id}
                                onPageSizeChange={pageSize => {
                                    setPageSize(pageSize);
                                    setPlrPageNo(0);
                                }}
                                onPageChange={setPlrPageNo}
                                rowsPerPageOptions={rowsPerPageOptions}
                                pagination
                                loading={loading}
                                getRowClassName={() => `table-rows`}
                                page={plrPageNo}
                                paginationMode='server'
                                components={{
                                    // Toolbar: DatagridToolbar,
                                    LoadingOverlay: LinearProgress,
                                    Footer: DatagridFooter,
                                    NoRowsOverlay: DatagridNoRowsOverlay
                                }}
                            />
                        ) :
                            <DataGrid
                                sx={styles.datagrid}
                                rowSpacingType='margin'
                                sortingOrder={['desc', 'asc']}
                                checkboxSelection={false}
                                density='standard'
                                rows={nonPlrKey}
                                columns={nonPlrColumns as any}
                                rowCount={nonPlrRowCount}
                                pageSize={pageSize}
                                getRowId={row => row.id}
                                onPageSizeChange={pageSize => {
                                    setPageSize(pageSize);
                                    setNonPlrPageNo(0);
                                }}
                                onPageChange={setNonPlrPageNo}
                                rowsPerPageOptions={rowsPerPageOptions}
                                pagination
                                loading={loading}
                                getRowClassName={() => `table-rows`}
                                page={nonPlrPageNo}
                                paginationMode='server'
                                components={{
                                    // Toolbar: DatagridToolbar,
                                    LoadingOverlay: LinearProgress,
                                    Footer: DatagridFooter,
                                    NoRowsOverlay: DatagridNoRowsOverlay
                                }}
                            />
                    }
                    <Dialog
                        open={showEditDialog}
                        onClose={closeEdit}
                        maxWidth='lg'
                        fullWidth>
                        <LabelSectionEditDialog closeEdit={closeEdit} docs_id={docsId} application_number={applicationNumber} status={status} searchText={searchText} />
                    </Dialog>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default memo(LabelSection)